import { useMemo } from 'react';
import { StackedSegment } from 'src/components/agile/agileComponents/StackedCapacityBar';

type CurrentZoneRowData = {
  asin: string;
  title: string;
  remainingFacings: number;
};

export const useZoneCapacityByAsinSegments = (currentZoneData: CurrentZoneRowData[]): StackedSegment[] => {
  return useMemo(() => {
    if (!currentZoneData.length) return [];
    return currentZoneData.map((item) => ({
      id: item.asin,
      label: item.title || 'Unknown',
      value: item.remainingFacings || 0,
    }));
  }, [currentZoneData]);
};
